import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Enlarger } from "components/modules/Editors/Enlarger/Enlarger";
import Head from "next/head";
import { translateFunc } from "client/utils/translateFunc";
import { commonLanguageFiles } from "client/config";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { CanvasProvider } from "client/contexts/ResizeEditor/Canvas";

const Home = () => {
    return (
        <>
            <Head>
                <title>{translateFunc("page-title")}</title>
            </Head>
            <ReduxProvider>
                <CanvasProvider>
                    <Enlarger />
                </CanvasProvider>
            </ReduxProvider>
        </>
    );
};

const files = ["enlarger-editor", ...commonLanguageFiles];

const LanguageWrapper = () => (
    <LanguageProvider files={files}>
        <Home />
    </LanguageProvider>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
